<template>
  <div class="row plain-element">
    <div v-if="!isLoggedIn()" class="dashboard-cards">
      <NoPermissionComponent/>
    </div>
    <div v-if="getUsername()" class="dashboard" v-cloak>
        <div class="row row-cards">
        <div class="row row-break"></div>
        <div class="row text-center row-back">
            <span style="font-size: 24px;">  EM3's Area of Expertise </span>
        </div>
        <div class="card card-description">
            <div class="row">
                <div class="col col-12 col-sm-12 col-md-11 col-lg-3 plain-element">
                  <div class="col col-12 col-sm-12 col-md-8 col-lg-11 plain-element">
                      <span class="section-header" style="width: 80%">
                          Strategy, Management &amp; Compliance
                      </span>
                  </div>

                  <div class="input-field col col-12 col-sm-12 col-form">
                      <a target="_blank"
                         href="https://em3energy.com/service/energy-management-services/"
                         @click="recordInteraction('Energy Management')">
                          <div class="card menu-card">
                              <h5>
                                  <span class="material-icons chevron-right">chevron_right</span>
                                  Energy Management
                              </h5>
                          </div>
                      </a>
                  </div>

                  <div class="input-field col col-12 col-sm-12 col-form">
                      <a target="_blank"
                         href="https://em3energy.com/service/programme-development/"
                         @click="recordInteraction('Carbon Roadmap Generation')">
                          <div class="card menu-card">
                              <h5>
                                  <span class="material-icons chevron-right">chevron_right</span>
                                  Carbon Roadmap Generation
                              </h5>
                          </div>
                      </a>
                  </div>

                  <div class="input-field col col-12 col-sm-12 col-form">
                      <a target="_blank"
                         href="https://em3energy.com/service/programme-development/"
                         @click="recordInteraction('Corporate Net Zero Plans')">
                          <div class="card menu-card">
                              <h5>
                                  <span class="material-icons chevron-right">chevron_right</span>
                                  Corporate Net Zero Plans
                              </h5>
                          </div>
                      </a>
                  </div>

                  <div class="input-field col col-12 col-sm-12 col-form">
                      <a target="_blank"
                         href="https://em3energy.com/service/consultancy/"
                         @click="recordInteraction('Energy Performance Indicator Mapping')">
                          <div class="card menu-card">
                              <h5>
                                  <span class="material-icons chevron-right">chevron_right</span>
                                  Energy Performance Indicator Mapping
                              </h5>
                          </div>
                      </a>
                  </div>

                  <div class="input-field col col-12 col-sm-12 col-form">
                      <a target="_blank"
                         href="https://em3energy.com/service/consultancy/"
                         @click="recordInteraction('ISO50001 Compliance Support')">
                          <div class="card menu-card">
                              <h5>
                                  <span class="material-icons chevron-right">chevron_right</span>
                                  ISO50001 Compliance Support
                              </h5>
                          </div>
                      </a>
                  </div>

                  <div class="input-field col col-12 col-sm-12 col-form">
                      <a target="_blank"
                         href="https://em3energy.com/service/consultancy/"
                         @click="recordInteraction('SECR Compliance')">
                          <div class="card menu-card">
                              <h5>
                                  <span class="material-icons chevron-right">chevron_right</span>
                                  SECR Compliance
                              </h5>
                          </div>
                      </a>
                  </div>

                  <div class="input-field col col-12 col-sm-12 col-form">
                      <a target="_blank"
                         href="https://em3energy.com/service/energy-management-services/"
                         @click="recordInteraction('Metering')">
                          <div class="card menu-card">
                              <h5>
                                  <span class="material-icons chevron-right">chevron_right</span>
                                  Metering
                              </h5>
                          </div>
                      </a>
                  </div>

                  <div class="input-field col col-12 col-sm-12 col-form">
                      <a target="_blank"
                         href="https://em3energy.com/service/consultancy/"
                         @click="recordInteraction('Meter Gap Analysis')">
                          <div class="card menu-card">
                              <h5>
                                  <span class="material-icons chevron-right">chevron_right</span>
                                  Meter Gap Analysis
                              </h5>
                          </div>
                      </a>
                  </div>
              </div>
                <div class="col col-12 col-sm-12 col-md-11 col-lg-3 plain-element">
                  <div class="col col-12 col-sm-12 col-md-8 col-lg-11 plain-element">
                      <span class="section-header" style="width: 80%">Audits &amp; Technical Assessments</span>
                  </div>

                  <div class="input-field col col-12 col-sm-12 col-form">
                      <a target="_blank"
                         href="https://em3energy.com/service/consultancy/"
                         @click="recordInteraction('Energy Auditing')">
                          <div class="card menu-card">
                              <h5><span class="material-icons chevron-right">chevron_right</span> Energy Auditing</h5>
                          </div>
                      </a>
                  </div>

                  <div class="input-field col col-12 col-sm-12 col-form">
                      <a target="_blank"
                         href="https://em3energy.com/service/consultancy/"
                         @click="recordInteraction('ESOS Energy Audits')">
                          <div class="card menu-card">
                              <h5><span class="material-icons chevron-right">chevron_right</span> ESOS Energy Audits</h5>
                          </div>
                      </a>
                  </div>

                  <div class="input-field col col-12 col-sm-12 col-form">
                      <a target="_blank"
                         href="https://em3energy.com/service/consultancy/"
                         @click="recordInteraction('Energy Efficiency Directive (EED) Audits')">
                          <div class="card menu-card">
                              <h5><span class="material-icons chevron-right">chevron_right</span> Energy Efficiency Directive (EED) Audits</h5>
                          </div>
                      </a>
                  </div>

                  <div class="input-field col col-12 col-sm-12 col-form">
                      <a target="_blank"
                         href="https://em3energy.com/service/consultancy/"
                         @click="recordInteraction('Water Audits')">
                          <div class="card menu-card">
                              <h5><span class="material-icons chevron-right">chevron_right</span> Water Audits</h5>
                          </div>
                      </a>
                  </div>

                  <div class="input-field col col-12 col-sm-12 col-form">
                      <a target="_blank"
                         href="https://em3energy.com/service/discovery/"
                         @click="recordInteraction('Air Compressor Studies')">
                          <div class="card menu-card">
                              <h5><span class="material-icons chevron-right">chevron_right</span> Air Compressor Studies</h5>
                          </div>
                      </a>
                  </div>

                  <div class="input-field col col-12 col-sm-12 col-form">
                      <a target="_blank"
                         href="https://em3energy.com/service/discovery/"
                         @click="recordInteraction('Chilled Water Studies')">
                          <div class="card menu-card">
                              <h5><span class="material-icons chevron-right">chevron_right</span> Chilled Water Studies</h5>
                          </div>
                      </a>
                  </div>

                  <div class="input-field col col-12 col-sm-12 col-form">
                      <a target="_blank"
                         href="https://em3energy.com/service/discovery/"
                         @click="recordInteraction('Heat & Mass Balance Studies')">
                          <div class="card menu-card">
                              <h5><span class="material-icons chevron-right">chevron_right</span> Heat &amp; Mass Balance Studies</h5>
                          </div>
                      </a>
                  </div>

                  <div class="input-field col col-12 col-sm-12 col-form">
                      <a target="_blank"
                         href="https://em3energy.com/service/discovery/"
                         @click="recordInteraction('Thermal Studies')">
                          <div class="card menu-card">
                              <h5><span class="material-icons chevron-right">chevron_right</span> Thermal Studies</h5>
                          </div>
                      </a>
                  </div>
              </div>
                <div class="col col-12 col-sm-12 col-md-11 col-lg-3 plain-element">
                  <div class="col col-12 col-sm-12 col-md-8 col-lg-11 plain-element">
                      <span class="section-header" style="width: 80%">
                          Engineering, Systems &amp; Decarbonisation
                      </span>
                  </div>

                  <div class="input-field col col-12 col-sm-12 col-form">
                      <a target="_blank"
                         href="https://em3energy.com/service/project-design-delivery/"
                         @click="recordInteraction('Energy Efficient Design')">
                          <div class="card menu-card">
                              <h5>
                                  <span class="material-icons chevron-right">chevron_right</span>
                                  Energy Efficient Design
                              </h5>
                          </div>
                      </a>
                  </div>

                  <div class="input-field col col-12 col-sm-12 col-form">
                      <a target="_blank"
                         href="https://em3energy.com/service/programme-development/"
                         @click="recordInteraction('High Temperature Heat Pumps')">
                          <div class="card menu-card">
                              <h5>
                                  <span class="material-icons chevron-right">chevron_right</span>
                                  High Temperature Heat Pumps
                              </h5>
                          </div>
                      </a>
                  </div>

                  <div class="input-field col col-12 col-sm-12 col-form">
                      <a target="_blank"
                         href="https://em3energy.com/service/programme-development/"
                         @click="recordInteraction('Steam Generating Heat Pumps')">
                          <div class="card menu-card">
                              <h5>
                                  <span class="material-icons chevron-right">chevron_right</span>
                                  Steam Generating Heat Pumps
                              </h5>
                          </div>
                      </a>
                  </div>

                  <div class="input-field col col-12 col-sm-12 col-form">
                      <a target="_blank"
                         href="https://em3energy.com/service/project-design-delivery/"
                         @click="recordInteraction('Steam Mapping')">
                          <div class="card menu-card">
                              <h5>
                                  <span class="material-icons chevron-right">chevron_right</span>
                                  Steam Mapping
                              </h5>
                          </div>
                      </a>
                  </div>
              </div>
                <div class="col col-12 col-sm-12 col-md-11 col-lg-3 plain-element">
                  <div class="col col-12 col-sm-12 col-md-8 col-lg-11 plain-element">
                      <span class="section-header" style="width: 80%">Project Delivery, Digital &amp; Advisory</span>
                  </div>

                  <div class="input-field col col-12 col-sm-12 col-form">
                      <a target="_blank"
                         href="https://em3energy.com/service/project-design-delivery/"
                         @click="recordInteraction('Project Management')">
                          <div class="card menu-card">
                              <h5><span class="material-icons chevron-right">chevron_right</span> Project Management</h5>
                          </div>
                      </a>
                  </div>

                  <div class="input-field col col-12 col-sm-12 col-form">
                      <a target="_blank"
                         href="https://em3energy.com/service/project-design-delivery/"
                         @click="recordInteraction('Construction Management')">
                          <div class="card menu-card">
                              <h5><span class="material-icons chevron-right">chevron_right</span> Construction Management</h5>
                          </div>
                      </a>
                  </div>

                  <div class="input-field col col-12 col-sm-12 col-form">
                      <a target="_blank"
                         href="https://em3energy.com/service/project-design-delivery/"
                         @click="recordInteraction('Commissioning')">
                          <div class="card menu-card">
                              <h5><span class="material-icons chevron-right">chevron_right</span> Commissioning</h5>
                          </div>
                      </a>
                  </div>

                  <div class="input-field col col-12 col-sm-12 col-form">
                      <a target="_blank"
                         href="https://em3energy.com/service/consultancy/"
                         @click="recordInteraction('3D Scanning')">
                          <div class="card menu-card">
                              <h5><span class="material-icons chevron-right">chevron_right</span> 3D Scanning</h5>
                          </div>
                      </a>
                  </div>

                  <div class="input-field col col-12 col-sm-12 col-form">
                      <a target="_blank"
                         href="https://em3energy.com/service/consultancy/"
                         @click="recordInteraction('Equipment Tender Analysis')">
                          <div class="card menu-card">
                              <h5><span class="material-icons chevron-right">chevron_right</span> Equipment Tender Analysis</h5>
                          </div>
                      </a>
                  </div>

                  <div class="input-field col col-12 col-sm-12 col-form">
                      <a target="_blank"
                         href="https://em3energy.com/service/consultancy/"
                         @click="recordInteraction('Life Cycle Assessments')">
                          <div class="card menu-card">
                              <h5><span class="material-icons chevron-right">chevron_right</span> Life Cycle Assessments</h5>
                          </div>
                      </a>
                  </div>

                  <div class="input-field col col-12 col-sm-12 col-form">
                      <a target="_blank"
                         href="https://em3energy.com/service/programme-development/"
                         @click="recordInteraction('Grant Funding Application Support')">
                          <div class="card menu-card">
                              <h5><span class="material-icons chevron-right">chevron_right</span> Grant Funding Application Support</h5>
                          </div>
                      </a>
                  </div>
              </div>
            </div>
        </div>
    </div>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import NoPermissionComponent from "@/components/NoPermissionComponent.vue";


export default {
  name: "AvailableServicesView",
  components: {
    NoPermissionComponent,

  },
  props: {

  },

  methods: {
    ...mapGetters(["getUsername", "isLoggedIn", "getLoader","getFormError",]),
    ...mapActions(["performSetFormError", "fetchMeterHealthCheckDashboards", "performRecordUserInteraction"]),

    recordInteraction(service) {
      this.performRecordUserInteraction({
        "username": this.getUsername(),
        "service": service
      })
    },
  },
  created() {
    document.title = "EM3 Services";
    this.performSetFormError(null)
    this.performRecordUserInteraction({
      "username": this.getUsername(),
      "service": "Main Page"
    })
    window.scrollTo(0,0);
  }
}
</script>